export default "__VITE_ASSET__DEA7qX9e__"